import styled from 'styled-components';
import { darken, transparentize } from 'polished';

export const Container = styled.section`
  min-height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  table {
    width: 100%;
    font-size: 12px;
    border-radius: ${({ theme }) => theme.metrics.innerRadius};
    border-collapse: collapse;
    overflow: hidden;

    thead {
      tr {
        background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
        color: ${({ theme }) => theme.colors.textBackground};

        th {
          padding: 5px;
          text-transform: uppercase;
          text-align: left;
        }
      }
    }

    tbody {
      tr {
        background-color: ${({ theme }) => theme.colors.background};
        transition: 0.2s;
        cursor: pointer;

        &:nth-child(odd) {
          background-color: ${({ theme }) => darken(0.025, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.025, theme.colors.error)};
            }
          }
        }

        td {
          padding: 5px;
          font-size: 12px;
          color: ${({ theme }) => theme.colors.textBackground};

          &.feriado {
            background-color: ${({ theme }) => theme.colors.error};
          }

          &.progesso_carga_horaria {
            position: relative;
            z-index: 1;

            &:before {
              content: '';
              width: var(--progesso_carga_horaria);
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: -1;
              background-image: linear-gradient(
                ${({ theme }) => transparentize(0.45, theme.colors.success)},
                ${({ theme }) => transparentize(0.45, theme.colors.success)}
              );
            }
          }
        }

        &:hover {
          background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.05, theme.colors.error)};
            }
          }
        }

        &.semestre_1 {
          background-image: linear-gradient(
            ${({ theme }) => transparentize(0.75, theme.colors.color2)},
            ${({ theme }) => transparentize(0.75, theme.colors.color2)}
          );
          background-repeat: no-repeat;
        }

        &.semestre_2 {
          background-image: linear-gradient(
            ${({ theme }) => transparentize(0.75, theme.colors.color3)},
            ${({ theme }) => transparentize(0.75, theme.colors.color3)}
          );
          background-repeat: no-repeat;
        }

        &.semestre_3 {
          background-image: linear-gradient(
            ${({ theme }) => transparentize(0.75, theme.colors.color4)},
            ${({ theme }) => transparentize(0.75, theme.colors.color4)}
          );
          background-repeat: no-repeat;
        }
      }
    }
  }

  /* Ocultar a 8ª coluna (Ocupação) na impressão */
  @media print {
    table {
      th:nth-child(8),
      td:nth-child(8) {
        display: none !important;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.metrics.tablet_medium}) {
    margin: 0;
    overflow-x: auto;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.primary};

  @media print {
    display: none;
  }
`;

export const Title = styled.h1`
  width: 100%;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const HeaderImpressao = styled.table`
  width: 100%;
  display: none;
  margin-bottom: 5px;
  font-size: 12px;
  border-collapse: collapse;
  overflow: hidden;

  @media print {
    display: table;
  }

  thead {
    width: 100%;
    padding: 5px;
    font-size: 18px;
    font-weight: bold;

    tr {
      border: 1px solid black;

      th {
        padding: 10px;
        text-align: center;
        border: 1px solid black;
      }
    }
  }

  tbody {
    tr {
      border: 1px solid black;

      td {
        padding: 5px;
        border: 1px solid black;
        font-weight: bold;
      }
    }
  }
`;

export const ContainerApoio = styled.div`
  min-height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  p {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  @media print {
    padding: 0;
    margin-bottom: 10px;

    p {
      font-size: 10px;
      color: #000000 !important;
    }
  }
`;